import { API } from '../Api';
import { IPostModel } from '../../models';

export interface UserSearchItem {
  id: string;
  userName?: string;
  fullName?: string;
  avatar?: string;
  followerCount: number;
}

// Tìm user: BE đã xếp ưu tiên khớp đúng tên → nhiều follower.
export const searchUsers = (
  keyword: string,
  pageNumber = 1,
  pageSize = 10
) => {
  return API.get<UserSearchItem[]>('/v1/user-service/users/search', {
    params: { keyword, pageNumber, pageSize },
  }).then((res) => res.data ?? []);
};

interface PostSearchPage {
  data: IPostModel[];
  pageNumber: number;
  pageSize: number;
  total: number;
  hasMore: boolean;
}

// Tìm post: BE khớp content/title/hashtag, xếp theo nhiều like.
export const searchPosts = (
  keyword: string,
  pageNumber = 1,
  pageSize = 10
) => {
  return API.get<PostSearchPage>('/v1/post-service/posts/search', {
    params: { keyword, pageNumber, pageSize },
  }).then((res) => res.data);
};
